<template>
	<div class="content">
		<div class="row animated fadeIn">
			<div class="col-md-12">
				<Alert :type="alertType" :message="alertMessage" v-if="alertShow === true"/>
        <ul class="nav nav-pills-primary jobs nav-fill mb-10" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" data-toggle="tab" href="#joblogs" role="tablist" @click="activeTab='job-logs'">Job Logs</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#apilogs" role="tablist" @click="activeTab='api-logs'">API Logs</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#otherlogs" role="tablist" @click="activeTab='other-logs'">Other Logs</a>
          </li>
        </ul>
			</div>
    </div>
    <div class="tab-content tab-space tab-subcategories">
      <div class="tab-pane active" id="joblogs" v-if="activeTab==='job-logs'">
        <div class="card pl-10 pr-10">
          <div class="card-header">
            <h4 class="card-title fw-600">Background Jobs Logging Details</h4>
          </div>
          <div class="card-body" style="padding-top: 0 !important;">
            <newJobLogs />
          </div>
        </div>
      </div>
      <div class="tab-pane" id="apilogs" v-if="activeTab==='api-logs'">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">API Error Logs</h4>
          </div>
          <div class="card-body">
            <api-error-list />
          </div>
        </div>
      </div>
      <div class="tab-pane" id="otherlogs" v-if="activeTab==='other-logs'">
        <ApplicationLogs/>
      </div>
    </div>
	</div>
</template>

<script>
	import ApplicationLogs from "@/components/Admin/Logs/ApplicationLogs/index.vue";

  export default {
		name: "createdUserList",
    components: {
          ApplicationLogs,
            Alert: () =>
                import(/* webpackChunkName: "alert" */ "../../../components/Alerts.vue"),
            LogsList: () =>
                import(/* webpackChunkName: "userList" */ "../../../components/Admin/Logs/ApplicationLogs/index.vue"),
            apiErrorList: () =>
                import(/* webpackChunkName: "userList" */ "../../../components/Admin/Logs/apiErrorList.vue"),
          newJobLogs: () =>
                import(/* webpackChunkName: "userList" */ "../../../components/Admin/Logs/newJobLogs.vue"),
			JobLogsList: () =>
					import(/* webpackChunkName: "userList" */ "../../../components/Admin/Logs/JobLogList.vue")
        },
    computed: {
            alertType() {
                return this.$store.getters["alert/type"];
            },
            alertMessage() {
                return this.$store.getters["alert/message"];
            },
            alertShow() {
                return this.$store.getters["alert/show"];
            },
            hasAllCustomer() {
                return this.$store.getters["customer/hasAllCustomers"]
            }
        },
    data(){
      return {
       activeTab: "job-logs",
      }
    },
    methods:{
      removeLogs(){
        this.$refs.logListRef.deleteLogs()
      }
    }
	};
</script>
